var $ = jQuery;
var index = 0;

$(document).on('ready', function(){
    $(document).on('click', '.num-bedrooms', function() {
        index = $(this).attr('index');
        $('#field_rru2o').val(index);
        $('.num-bedrooms').each(function(i, obj) {
            obj.classList.remove('selected');      
            if(obj.getAttribute('index') == index) {
                if (obj.classList.contains('show')) {
                    obj.classList.remove('selected')
                } else {
                    obj.classList.add('selected');    
                }  
            }
       })
    })
    
    $(document).on('click', '.list-btn', function() {
        $('.submit-property').trigger('click');
        // window.scrollTo(0,0);
        // $('body').addClass('overflow-hidden');
        // $('.list-property-success-overlay').removeClass('hidden');
    })

    $(document).on('click', '.remove-overlay', function() {
        $('.list-property-success-overlay').addClass('hidden');
        $('body').removeClass('overflow-hidden');

    })

    if($('.frm_message').length){
        $('body').addClass('overflow-hidden');
        $('.list-property-success-overlay').removeClass('hidden');
        $('.bedrooms-section').addClass('hidden');
        $('.submit-section').addClass('hidden');

    }

})
